(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["coupon-copy-banner"] && !Shopify.designMode) return;
  try {
    if (!window.__ccbInit) {
    window.__ccbInit = true;

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-copy-code]');
      if (!btn) return;

      const code = btn.dataset.copyCode;
      const codeEl = btn.querySelector('[data-ccb-code]');
      const copiedEl = btn.querySelector('[data-ccb-copied]');

      if (!code) return;

      const liveEl = btn.closest('.coupon-copy-banner')?.querySelector('[data-ccb-live]');

      const showCopied = function () {
        if (codeEl) codeEl.hidden = true;
        if (copiedEl) copiedEl.hidden = false;
        if (liveEl) liveEl.textContent = copiedEl ? copiedEl.textContent : 'Copied!';
        setTimeout(function () {
          if (codeEl) codeEl.hidden = false;
          if (copiedEl) copiedEl.hidden = true;
          if (liveEl) liveEl.textContent = '';
        }, 2000);
      };

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(code)
          .then(showCopied)
          .catch(function () {
            fallbackCopy(code, showCopied);
          });
      } else {
        fallbackCopy(code, showCopied);
      }
    });

    function fallbackCopy(code, cb) {
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        cb();
      } catch (err) {}
      document.body.removeChild(ta);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-promises"] && !Shopify.designMode) return;
  try {
    (function () {
    const wrapper = document.getElementById('sp-{{ block.id }}');
    if (!wrapper) return;

    const icon      = wrapper.querySelector('[data-stock-icon]');
    const label     = wrapper.querySelector('[data-stock-label]');
    const threshold = parseInt(wrapper.dataset.lowThreshold, 10) || 5;
    const labels    = {
      in_stock: wrapper.dataset.labelInStock,
      low:      wrapper.dataset.labelLowStock,
      sold_out: wrapper.dataset.labelSoldOut
    };
    const states = ['in_stock', 'low', 'sold_out'];

    function updateStock(variant) {
      if (!variant) return;
      let state = 'in_stock';
      if (!variant.available) {
        state = 'sold_out';
      } else if (
        variant.inventory_management === 'shopify' &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= threshold
      ) {
        state = 'low';
      }
      states.forEach(function (s) { icon.classList.remove('sp-inv-icon--' + s); });
      icon.classList.add('sp-inv-icon--' + state);
      label.textContent = labels[state];
    }

    document.addEventListener('variant:update', function (e) {
      updateStock(e.detail && e.detail.variant);
    });
    document.addEventListener('variant:selected', function (e) {
      updateStock(e.detail && e.detail.variant);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
